import AppLoader from 'components/AppLoader'
import React, { Suspense } from 'react'

export default function withSuspenseFallback(Component) {
    return function DefaultFallback(props) {
        return (
            <Suspense fallback={<AppLoader />}>
                <Component {...props} />
            </Suspense>
        )
    }
}
